// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"705d3be04bc2af06","7663":"ca766e9d030f506b"}[chunkId] + ".css";
};